/**
 * Deploy-specific interface_config whitelists.
 */
export default [
    'LIVE_STREAMING_HELP_LINK',
    'SUPPORT_URL'
];
